import produce, { Draft } from 'immer';
import type { StoreApi, UseBoundStore } from 'zustand';

/** Helper to make using immer.produce easier inside of components */
export const produceState =
  <State extends { document?: object | null }, Args extends any[]>(
    store: UseBoundStore<StoreApi<State>>,
    action: (
      state: Draft<Omit<State, 'document'> & { document: Required<NonNullable<State['document']>> }>,
      ...args: Args
    ) => State | void | undefined
  ) =>
  (...args: Args) =>
    store.setState(
      produce<State>((state) => {
        if (!state.document) return;
        return action(state as Draft<Omit<State, 'document'> & { document: Required<NonNullable<State['document']>> }>, ...args);
      })
    );
